/**
 * Manifest auth — feature shell-less.
 *
 * @remarks
 * Auth est rendue par `AuthLayout`, **pas par AppShell**. Donc :
 * - Pas de `centerView` (la route a son element direct)
 * - Pas de `panels` ni `headerSlot`
 * - Pas de `navigation` (login pas un lien sidebar)
 * - Pas de `enabledWhen` (login accessible sans auth, c'est le point d'entrée)
 *
 * Le manifest existe juste pour respecter le pattern et permettre au registry
 * d'agréger toutes les features uniformément.
 */

import type { FeatureManifest } from '@/app/registry';
import { authRoutes } from './routes';

export const authManifest: FeatureManifest = {
  id: 'auth',
  contexts: [], // pas de context shell — auth est en dehors

  routes: [{ zone: 'auth', routes: authRoutes }],
};
